// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__Ta5Ne","mainContent":"style_mainContent__qcBoB"};